import {
  Button,
  Modal,
  ModalIcon,
  Spacer,
  Stack,
  TextBody,
  TextTitle,
} from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';
import { FC } from 'react';

interface DeleteUserConfirmationModalProps {
  userName: string;
  open: boolean;
  isDeletingUser: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteUserConfirmationModal: FC<
  DeleteUserConfirmationModalProps
> = ({ userName, open, isDeletingUser, onClose, onDelete }) => {
  const [t] = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <div slot="header" style={{ textAlign: 'center' }}>
        <ModalIcon name="error" />
      </div>
      <TextTitle size="small">
        {t('manager/users:userDetails.deleteUserConfirmationModal.title', {
          defaultValue: 'Delete {{userName}}?',
          userName,
        })}
      </TextTitle>
      <Spacer size="small" />
      <TextBody
        variant="secondary"
        i18nKey="manager/users:userDetails.deleteUserConfirmationModal.description"
      >
        This will remove all of their access. This cannot be undone.
      </TextBody>
      <Stack slot="footer" justifyContent="end">
        <Button
          variant="secondary"
          size="large"
          onClick={() => {
            onClose();
          }}
          disabled={isDeletingUser}
        >
          Cancel
        </Button>
        <Button
          variant="warning"
          size="large"
          onClick={() => {
            onDelete();
          }}
          disabled={isDeletingUser}
        >
          {isDeletingUser ? 'Deleting...' : 'Delete'}
        </Button>
      </Stack>
    </Modal>
  );
};
